import {getStoryTags, CreateStoryTagCategory, createStoryTagThunk, updateStoryTagCategoryThunk, updateStoryTagThunk, updateCategoryOrderThunk, getTagGroups, createTagGroupThunk, updateTagGroupThunk} from "../../thunk";

const getID = (id) => {
    return `a${id}a`
}

export default {
    [getStoryTags.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getStoryTags.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        console.log('TAGS RESULT');
        console.log(action.payload);
        state.data.tags = action.payload.result;
        state.data.categories = action.payload.category;
        state.queryParams = {...action.meta.arg ,page: +action.payload.page, perPage: +action.payload.perPage, total: +action.payload.totalCount}
    },
    [getStoryTags.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [CreateStoryTagCategory.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [CreateStoryTagCategory.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data.categories.push(action.payload);
    },
    [CreateStoryTagCategory.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [createStoryTagThunk.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [createStoryTagThunk.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data.tags.push(action.payload);
    },
    [createStoryTagThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [updateStoryTagCategoryThunk.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [updateStoryTagCategoryThunk.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        const updated = action.payload;
        const index = state.data.categories.findIndex((cat: any) => cat.id === updated.id);
        if (index !== -1) {
            state.data.categories[index] = updated;
        }
    },
    [updateStoryTagCategoryThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [updateStoryTagThunk.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [updateStoryTagThunk.fulfilled as any]: (state, action) => {
        const updated = action.payload;
        const index = state.data.tags.findIndex((tag: any) => tag.id === updated.id);
        if (index !== -1) {
            state.data.tags[index] = updated;
        }
        state.status = 'resolved';
    },
    [updateStoryTagThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    },
    [updateCategoryOrderThunk.pending as any]: (state) => {
        state.status = 'loading';
    },
    [updateCategoryOrderThunk.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
    },
    [updateCategoryOrderThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
    },
    [getTagGroups.pending as any]: (state) => {
        state.tagGroupsStatus = 'loading';
        state.error = null;
    },
    [getTagGroups.fulfilled as any]: (state, action) => {
        state.tagGroupsStatus = 'resolved';
        state.data.tagGroups = action.payload.result || [];
        state.tagGroupsQueryParams = {
            ...action.meta.arg,
            page: +action.payload.page,
            perPage: +action.payload.perPage,
            total: +action.payload.totalCount,
        };
    },
    [getTagGroups.rejected as any]: (state, action) => {
        state.tagGroupsStatus = 'rejected';
        state.error = action.payload;
    },
    [createTagGroupThunk.pending as any]: (state) => {
        state.tagGroupsStatus = 'loading';
        state.error = null;
    },
    [createTagGroupThunk.fulfilled as any]: (state, action) => {
        state.tagGroupsStatus = 'resolved';
        if (!state.data.tagGroups) {
            state.data.tagGroups = [];
        }
        state.data.tagGroups.push(action.payload);
    },
    [createTagGroupThunk.rejected as any]: (state, action) => {
        state.tagGroupsStatus = 'rejected';
        state.error = action.payload;
    },
    [updateTagGroupThunk.pending as any]: (state) => {
        state.tagGroupsStatus = 'loading';
        state.error = null;
    },
    [updateTagGroupThunk.fulfilled as any]: (state, action) => {
        state.tagGroupsStatus = 'resolved';
        const updated = action.payload;
        if (!state.data.tagGroups) {
            state.data.tagGroups = [];
        }
        const index = state.data.tagGroups.findIndex((g: any) => g.id === updated.id);
        if (index !== -1) {
            state.data.tagGroups[index] = updated;
        }
    },
    [updateTagGroupThunk.rejected as any]: (state, action) => {
        state.tagGroupsStatus = 'rejected';
        state.error = action.payload;
    },

}
